module.exports = __webpack_public_path__ + "static/mark-e147a4c25564971f07a370e5a8575e47.jpg";